const InvoiceAnalysisEvent = `
  id
  analysis
  description
  updatedAt
`;

export default InvoiceAnalysisEvent;
